import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowLeft, ChevronDown } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { BANNER_HEIGHT, BREADCRUMBS_HEIGHT, TEXT } from '../../config/constants';
import ButtonLink from '../ButtonLink';
import css from './ImageText.module.scss';
import Image from '../Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ImageText = function ImageText(_ref) {
  var className = _ref.className,
      centerContent = _ref.centerContent,
      cta = _ref.cta,
      description = _ref.description,
      image = _ref.image,
      ratio4x1 = _ref.ratio4x1,
      subtitle = _ref.subtitle,
      subtitleUrl = _ref.subtitleUrl,
      textColor = _ref.textColor,
      title = _ref.title;
  var rootRef = useRef();

  var scrollToContent = function scrollToContent() {
    var rootEl = rootRef.current;

    if (!rootEl) {
      return false;
    }

    var top = rootEl.offsetHeight + BANNER_HEIGHT + BREADCRUMBS_HEIGHT;
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
    return true;
  };

  var rootClass = cc([className, css.root, _defineProperty({}, css.ratio4x1, ratio4x1)]);
  var innerClass = cc([css.inner, _defineProperty({}, css.centerContent, centerContent)]);
  var hasCornerLink = subtitle !== '' && subtitleUrl;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("header", {
      className: rootClass,
      ref: rootRef,
      children: [/*#__PURE__*/_jsx("div", {
        className: innerClass,
        children: /*#__PURE__*/_jsxs("div", {
          className: css.text,
          children: [title && /*#__PURE__*/_jsx("h1", {
            className: css.title,
            dangerouslySetInnerHTML: {
              __html: title
            },
            style: {
              color: textColor
            }
          }), description && /*#__PURE__*/_jsx("p", {
            className: css.description,
            dangerouslySetInnerHTML: {
              __html: description
            },
            style: {
              color: textColor
            }
          }), cta && /*#__PURE__*/_jsx(ButtonLink, {
            href: cta.href,
            white: cta.white,
            children: cta.text
          }), /*#__PURE__*/_jsxs("button", {
            "aria-label": TEXT.scrollDown,
            className: css.jumper,
            onClick: scrollToContent,
            style: {
              color: textColor
            },
            title: TEXT.scrollDown,
            type: "button",
            children: ["Explore", /*#__PURE__*/_jsx(ChevronDown, {})]
          })]
        })
      }), image && /*#__PURE__*/_jsx("div", {
        className: css.img,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          alt: title,
          lazyload: false,
          sizes: [480, 600, 800, 1200, 1600]
        }))
      }), hasCornerLink && /*#__PURE__*/_jsxs("a", {
        "aria-label": "Go To ".concat(subtitle),
        className: css.cornerLink,
        href: subtitleUrl,
        style: {
          color: textColor
        },
        children: [/*#__PURE__*/_jsx(ArrowLeft, {}), subtitle]
      })]
    })
  });
};

ImageText.defaultProps = {
  className: false,
  centerContent: false,
  cta: false,
  description: false,
  image: false,
  ratio4x1: false,
  textColor: '',
  title: false,
  subtitleUrl: false
};
ImageText.propTypes = {
  centerContent: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  cta: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string,
    white: PropTypes.bool
  })]),
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  ratio4x1: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape]),
  textColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitleUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default ImageText;